export default __webpack_public_path__ + "static/media/tip12.101be8d8.png";